import React from 'react';
import { faTruckFast } from '@fortawesome/pro-regular-svg-icons/faTruckFast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function TruckFastRegularIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faTruckFast} {...props} />;
}
